export const itemListData=[
    {
        key:1,
        lable:'مواد غذایی و خوراکی'
    },
    {
        key:2,
        lable:'پوشاک'
    },
    {
        key:3,
        lable:"وسایل مربوط به خانه"
    },
    {
        key:4,
        lable:"لوازم برقی"
    },
    {
        key:5,
        lable:"وسایل شخصی"
    },
    {
        key:6,
        lable:"آرایشی بهداشتی درمان"
    },
    {
        key:7,
        lable:"لوازم الکترونیکی"
    },
    {
        key:8,
        lable:"زیورآلات"
    },
    {
        key:9,
        lable:"قطعات خودرو"
    },
    {
        key:10,
        lable:"تجهیزات ماشیان الات صنعتی"
    },
    {
        key:11,
        lable:"پاکت نامه"
    },
    {
        key:12,
        lable:"سایر"
    },
]